module.exports = __webpack_public_path__ + "static/img/login_bg2.c416649.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/loginLuobei/img/login_bg2.jpg
// module id = 42d4
// module chunks = 183